import type { CardBlock } from "@go-novus/admin-api";
import { z } from "zod";

/** 快照只保存发起登录所需的公开引用；不保存服务端任意 payload 或登录 URL。 */
export const verificationPromptSchema = z.object({
  requestId: z.string().min(1).max(128),
  intent: z.enum(["continue", "restore"]),
  expiresAt: z.iso.datetime(),
  lifecycle: z.enum(["active", "expired", "revoked"]),
});

export type VerificationPrompt = z.infer<typeof verificationPromptSchema>;

/** 登录入口只来自 BFF 当前块；状态本身不授予动作。 */
export function verificationPrompt(
  block: CardBlock | undefined,
): VerificationPrompt | undefined {
  if (!block || block.status !== "ok" || block.type !== "verification")
    return undefined;
  return {
    requestId: block.data.auth_request_id,
    intent: "continue",
    expiresAt: block.data.expires_at,
    lifecycle:
      block.data.status === "pending"
        ? "active"
        : block.data.status === "expired"
          ? "expired"
          : "revoked",
  };
}
